export const CHILDREN = {
  isHidden: true,
  nickname: 'PRODUCTS.CHILDREN.nickname',
  icon:'children'
};
